export class GetMappingStats {
    public static readonly type: string = '[Mapping Stats] Get Mapping Stats';
}
